import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import ArticleLayout from "./ArticleLayout";
import RelatedGuides from "./RelatedGuides";

export default function LeasingOperationalFoaieParcursPage() {
  return (
    <>
      <Seo {...seoFromPublicPage("/leasing-operational-foaie-parcurs")} />
      <ArticleLayout
        eyebrow="Gestiune flotă"
        title="Leasing operațional: cine ține foaia de parcurs și ce deduci tu, nu firma de leasing"
        lead="Mașina e a firmei de leasing. Tu ești utilizatorul. Rata, combustibilul și foaia nu stau în același dosar, iar la control se leagă de aceeași perioadă. Fără foaie, nici rata nu rămâne la 100%."
      >
        <p>
          La leasing operațional, proprietarul rămâne firma de leasing. SRL-ul sau
          PFA-ul plătește rata și folosește mașina. Foaia de parcurs o ține
          utilizatorul, din ziua în care preia cheile până în ziua în care le predă
          înapoi.
        </p>
        <p>
          Inspectorul pune alături patru lucruri: contractul, procesul-verbal de
          predare cu indexul, foaia de parcurs și facturile de rată și de combustibil.
          Dacă una lipsește sau datele nu se suprapun, deducerea integrală cade pe tot
          pachetul, nu doar pe benzină.
        </p>

        <h2>Foaia e a utilizatorului, nu a firmei de leasing</h2>
        <p>
          Firma de leasing nu face deplasările și nu ține evidența pentru ANAF.
          Contractul îți dă dreptul să folosești mașina. Foaia arată ce ai făcut cu
          ea. Fără dreptul din contract, bonurile pe CUI nu au vehicul. Fără foaie,
          un autoturism obișnuit rămâne la 50%, inclusiv rata.
        </p>
        <p>
          Unele societăți de leasing cer un raport de kilometri, ca să închidă
          contractul sau să calculeze kilometrii peste limită. Raportul ăsta e pentru
          contract. Nu ține loc de foaie de parcurs: nu are scopul și locul fiecărei
          deplasări, nici norma de consum. ANAF cere foaia utilizatorului, cu cele
          patru elemente din{" "}
          <Link to="/ghid-foaie-parcurs-anaf">ghidul despre cerințele ANAF</Link>.
        </p>
        <p>
          O semnează cine a condus. Dacă a condus un angajat, foaia e a lui, iar
          firma păstrează documentul prin care i-a dat mașina. Predarea între șoferi
          e în{" "}
          <Link to="/masina-firma-angajati">
            articolul despre mașina folosită de angajați
          </Link>.
        </p>
        <p>
          Dacă contractul e pe administrator, ca persoană fizică, SRL-ul nu e
          utilizator. Atunci lipsește comodatul sau decontul de kilometri, nu o foaie
          pe firma de leasing.           Cazul e în{" "}
          <Link to="/masina-personala-srl-comodat">
            articolul despre mașina personală folosită de SRL
          </Link>.
        </p>

        <h2>Rata și combustibilul urmează aceeași regulă</h2>
        <p>
          Limita de 50% nu se oprește la pompă. <strong>Art. 298</strong> din Codul
          fiscal, pentru TVA, și <strong>art. 25 alin. (3) lit. l)</strong>, pentru
          impozitul pe profit, acoperă și chiria, și leasingul. Sub 3,5 tone și cu
          cel mult 9 locuri, rata unui autoturism stă în aceeași regulă cu
          combustibilul: <strong>50%</strong> dacă mașina e folosită și personal,{" "}
          <strong>100%</strong> dacă e exclusiv în activitate și dosarul o arată.
          Pentru o dubă, pragul de masă și de locuri e în{" "}
          <Link to="/autoutilitara-vs-autoturism-deductibilitate">
            articolul autoutilitară vs autoturism
          </Link>.
        </p>
        <p>
          La PFA, plățile din contractul de leasing sunt cheltuieli ale activității,
          cu aceeași alegere: 50% sau 100% cu foaie. Detaliile sunt în{" "}
          <Link to="/foi-parcurs-pfa">ghidul pentru PFA</Link>.
        </p>
        <p>
          Dacă deduci combustibilul integral și rata doar pe jumătate, sau invers,
          dosarul spune două lucruri diferite despre aceeași mașină. Regimul se alege
          o dată, pentru vehicul, și se aplică tuturor facturilor din lună.
          Condițiile pentru 100% — foaie, regulament intern, documente fiscale — sunt
          în{" "}
          <Link to="/deducere-100-combustibil">articolul despre deducerea 100%</Link>.
          Acolo sunt și categoriile care deduc integral fără foaie, cum sunt taxiul
          sau curieratul.
        </p>
        <p>
          Avansul din contract ține de aceeași cheltuială cu rata. Nu se deduce
          integral doar pentru că se plătește o singură dată, la început.
        </p>
        <p>
          Asigurarea inclusă în rată se deduce o dată, prin factura firmei de leasing.
          Dacă polița e plătită de societatea de leasing și e deja în rată, nu se mai
          trece și separat. O factură de RCA sau CASCO emisă direct pe firmă urmează
          aceeași regulă de 50% sau 100%, dar nu se adună peste suma deja cuprinsă în
          rată.
        </p>

        <h2>Luna de predare începe la indexul din procesul-verbal</h2>
        <p>
          Dacă mașina ajunge pe 18, foaia acoperă zilele de la 18 până la sfârșitul
          lunii. Zilele dinainte rămân goale: vehiculul nu era la tine. O foaie
          începută pe 1, cu curse dinainte de predare, arată că evidența a fost făcută
          din urmă.
        </p>
        <p>
          Indexul din procesul-verbal de predare-primire este kilometrul de start. Nu
          zero, și nu o cifră rotundă pusă din memorie. Bonurile și facturile de
          combustibil cu dată anterioară predării nu se leagă de acest contract. Data
          de pe documentul fiscal e cea care contează, nu data la care ajunge la
          contabil.
        </p>

        <h2>La final de contract, foaia se oprește în ziua returnării</h2>
        <p>
          Închiderea seamănă cu vânzarea. Foaia se oprește în ziua în care predai
          mașina, nu pe 31 și nu în ziua în care vine factura de penalizare. Indexul
          din procesul-verbal de returnare trebuie să coincidă cu ultimul total de pe
          foaie. Cum se închide o foaie la predare e în{" "}
          <Link to="/vanzare-masina-foaie-parcurs">
            articolul despre vânzarea mașinii
          </Link>.
        </p>
        <p>
          Kilometrii peste limita din contract se văd în două locuri. Firma de leasing
          îi calculează față de indexul de la returnare și emite o factură. ANAF îi
          caută pe foi. Limita din contract, indexul de la predare și totalul de pe
          foi trebuie să spună aceeași poveste.
        </p>
        <ul>
          <li>
            <strong>Penalizarea arată kilometri în plus, foile nu.</strong> Au existat
            drumuri neînregistrate. La 100%, acei kilometri nu au justificare.
          </li>
          <li>
            <strong>
              Foile arată mai mulți kilometri decât indexul de la returnare.
            </strong>{" "}
            Evidența declară curse pe care mașina nu le-a putut face.
          </li>
          <li>
            <strong>Nu există index pe procesul-verbal.</strong> Foaia rămâne
            neancorată, iar factura de kilometri suplimentari nu are cu ce se compara.
          </li>
        </ul>
        <p>
          Factura de kilometri peste limită este tot o cheltuială a vehiculului. Intră
          la 50% sau la 100% împreună cu rata și combustibilul. Nu repară o foaie
          lipsă și nu se deduce integral doar pentru că vine de la firma de leasing.
        </p>

        <h2>Două contracte în aceeași lună</h2>
        <p>
          Când un leasing se închide pe 12 și altul începe pe 18, fiecare mașină are
          propria foaie și propriul interval. Alimentările se repartizează pe
          vehiculul care era la tine în ziua bonului.
        </p>
        <div className="article-doc__table-wrap">
          <table className="article-doc__table">
            <thead>
              <tr>
                <th>Vehicul</th>
                <th>Interval pe foaie</th>
                <th>Ce nu intră</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Contractul vechi</td>
                <td>De la 1 până în ziua returnării</td>
                <td>Curse și bonuri de după predare</td>
              </tr>
              <tr>
                <td>Contractul nou</td>
                <td>Din ziua procesului-verbal de preluare</td>
                <td>Kilometri sau alimentări dinainte de preluare</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          Zilele dintre returnare și preluare rămân fără vehicul. Nu se acoperă cu
          deplasări pe mașina predată, nici pe cea care nu intrase încă.
        </p>

        <h2>Leasingul financiar începe tot la predare</h2>
        <p>
          Aici e leasingul operațional: plătești o rată, iar la final predai mașina.
          La leasingul financiar, vehiculul intră în evidența utilizatorului, iar
          factura desparte principalul de dobândă. Foaia începe tot în ziua predării,
          cu indexul din procesul-verbal. Limitarea de 50% se aplică în continuare
          cheltuielilor cu autoturismul, inclusiv amortizării, dacă mașina nu e
          folosită exclusiv în activitate. Ratele nu devin integral deductibile doar
          pentru că mașina e în evidența firmei.
        </p>

        <h2>Greșeli frecvente</h2>

        <h3>Nicio foaie, pentru că mașina nu e a firmei</h3>
        <p>
          Proprietarul e firma de leasing. Utilizatorul ești tu, iar deducerea se
          judecă la utilizator. Lipsa foii lasă rata și combustibilul la 50%, acolo
          unde vehiculul intră în limitare.
        </p>

        <h3>Raportul de kilometri către leasing, folosit ca foaie</h3>
        <p>
          Un total de kilometri pe an nu arată scopul deplasărilor. La control, el nu
          înlocuiește foaia.
        </p>

        <h3>Rată la 100%, combustibil la 50%</h3>
        <p>
          Aceeași mașină, același interval, două regimuri. Inspectorul ia regimul pe
          care dosarul îl poate susține, nu pe cel mai avantajos dintre ele.
        </p>

        <h3>Bonuri înainte de predare sau după returnare</h3>
        <p>
          Documentul fiscal cade în afara perioadei în care mașina era la tine.
          Cheltuiala nu are vehiculul pe care se sprijină.
        </p>

        <h3>CASCO din rată, dedus a doua oară</h3>
        <p>
          Polița plătită de firma de leasing și inclusă în factură e deja în cheltuială.
          A doua trecere dublează aceeași sumă.
        </p>

        <div className="article-doc__callout">
          <strong>În ziua preluării</strong>
          <p>
            Notează indexul din procesul-verbal, deschide foaia de la acea dată și nu
            atașa alimentări dinainte. La returnare, închide foaia pe același index cu
            care pleacă mașina.
          </p>
        </div>

        <h2>Concluzie</h2>
        <p>
          La leasing operațional, foaia de parcurs e a utilizatorului, din ziua
          predării până în ziua returnării. Rata, avansul, combustibilul și factura
          de kilometri peste limită urmează aceeași regulă, 50% sau 100%. Indexul din
          procesul-verbal ancorează ambele capete. Contractul pe persoană fizică nu
          se acoperă cu foaia firmei: acolo intră comodatul sau decontul de kilometri.
        </p>
        <RelatedGuides currentPath="/leasing-operational-foaie-parcurs" />
      </ArticleLayout>
    </>
  );
}
